import { ReactNode } from 'react'

interface Props {
  value: ReactNode
}

export const MessagingCustomHotkey = ({ value }: Props) => {
  return (
    <kbd className="bg-surface-subdued px-1 rounded-base-sm font-sans justify-center inline-flex text-xs text-content-subdued">
      {value}
    </kbd>
  )
}
